/**
 * Firebase Configuration for Client Portal
 *
 * Connected to spesialis-project for:
 * - Centralized activity logging
 * - Firebase Authentication for B2B clients
 * - Synced with Dashboard
 */
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Using spesialis-project for centralized logging (same as Dashboard & Parfum)
const firebaseConfig = {
    apiKey: "AIzaSyCW3_3AA_mfOEDkuZp8Hc__JB_gJ4OT4XE",
    authDomain: "spesialis-project.firebaseapp.com",
    projectId: "spesialis-project",
    storageBucket: "spesialis-project.firebasestorage.app",
    messagingSenderId: "170520867044",
    appId: "1:170520867044:web:2336256821e8ab91c87cf1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore for logging
export const db = getFirestore(app);

// Auth for client authentication
export const auth = getAuth(app);

export default app;
